{
  "button": {
    "showResults": "Show {{number}} Results",
    "noResults": "No Results"
  },
  "navbar": {
    "becomeAPartner": "Become a Partner",
    "switchToPartner": "Switch to Partner",
    "memberLogin": "Continue as a Renter",
    "ownerLogin": "Continue as an Owner",
    "memberLoginMenu": "Log In as Renter",
    "ownerLoginMenu": "Log In as Owner",
    "loginSignup": "Login / Signup"
  },
  "navigationButton": {
    "back": "Back",
    "next": "Next"
  },
  "loginModal": {
    "subtitle": "Your Rental Car. Unlocked."
  },
  "entry": {
    "cardTitle": "Log In Or Sign Up",
    "countryLabel": "Country",
    "phoneLabel": "Phone number",
    "phonePlaceholder": "(123)-456-7890",
    "continueGoogle": "Continue With Google",
    "continueApple": "Continue With Apple",
    "continueEmail": "Continue With Email",
    "legal": {
      "agreePrefix": "By clicking continue, you agree to our",
      "consentPrefix": "By providing your contact information, you agree to receive transactional and marketing messages by SMS and email. See our",
      "consentSuffix": "for details.",
      "termsAndConditions": "Terms of Service",
      "and": "and",
      "privacyPolicy": "Privacy Policy"
    },
    "renter": {
      "heroTitle": "No counter. No keys. No wait.",
      "heroSubtitle": "Skip the counter, unlock the car with your phone and be on the road in seconds.",
      "perkInstantUnlock": "Instant Unlock",
      "perkKeyless": "100% Keyless",
      "perkSelfDriving": "Self Driving Features Enabled",
      "switchPrompt": "Own an EV? ",
      "switchLink": "Continue as an owner"
    },
    "owner": {
      "cardTitle": "Log In as an Owner",
      "heroTitle": "You own the cars. We'll run the rentals.",
      "heroSubtitle": "Whether your EVs sit idle or grind on another platform, Eon runs every trip end to end, so you never meet a renter or hand over a key. You just collect the payouts.",
      "perkAvgPayout": "Avg $2,328/mo per car",
      "perkCoverage": "Up to $1M coverage",
      "perkOtherListings": "Keep your booking channels",
      "switchPrompt": "Looking to rent? ",
      "switchLink": "Continue as a renter"
    },
    "otp": {
      "title": "Verify your number",
      "bodyPrefix": "We sent a {{length}}-digit code to ",
      "codeLabel": "Verification code",
      "codePlaceholder": "Enter code",
      "verifyCode": "Verify Code",
      "resendPrompt": "Didn't get it? ",
      "resendLink": "Resend code",
      "resendCountdown": "Didn't get it? Resend code in {{time}}"
    },
    "finishSignup": {
      "title": "Set Up Your Profile",
      "subtitlePhone": "Profile is required for booking a car with Eon",
      "subtitleEmail": "This speeds up pickup and ID checks.",
      "continue": "Continue",
      "setUpLater": "Set It Up Later"
    },
    "emailForm": {
      "title": "Continue with email",
      "continue": "Continue",
      "loginTitle": "Log in with your E-mail and password",
      "createTitle": "Create a password",
      "createSubtitle": "This email doesn't have an account yet — set a password to create one.",
      "logIn": "Log In",
      "forgotPassword": "Forgot password"
    },
    "forgotPassword": {
      "title": "Reset Your Password",
      "body": "Enter your email and we'll send you a reset link.",
      "send": "Send Reset Link",
      "sentTitle": "Check Your Inbox",
      "sentBody": "We sent a reset link to {{email}}.",
      "sentCaption": "Not seeing it? Check your spam folder.",
      "openMailApp": "Open Mail App"
    }
  },
  "signin": {
    "subtitle": "Sign In to your Eon account",
    "body": "Log in with phone number, email or other accounts",
    "continue": "Continue",
    "or": "or",
    "emailButton": "Sign in with E-mail",
    "googleButton": "Sign in with Google",
    "appleButton": "Sign in with Apple",
    "noAccount": "Don't Have An Account? Sign Up"
  },
  "signup": {
    "subtitle": "Let's create your Eon account!",
    "alreadyHaveAcct": "I Already Have An Account",
    "continue": "Continue",
    "googleButton": "Sign up with Google",
    "appleButton": "Sign up with Apple"
  },
  "emailForm": {
    "subtitle": "Log in with your E-mail and password",
    "continue": "Continue",
    "forgotPassword": "Forgot password"
  },
  "forgotPassword": {
    "subtitle": "Reset Your Password",
    "body": "Type in your email and we'll send you a link where you can reset your password",
    "send": "Send"
  },
  "forgotPasswordSent": {
    "subtitle": "We sent you a link!",
    "body": "Check your mail and click on the link to continue",
    "goBack": "Go Back"
  },
  "confirmNewPassword": {
    "subtitle": "Confirm your new password",
    "button": "Update Password"
  },
  "confirmOtp": {
    "subtitle": "Please enter the One-Time password to verify your account",
    "body": "We have sent you a verification code to {{phone}}",
    "noCode": "Didn't receive a code?",
    "resentCode": "We've sent you a code wait {{timer}}s to",
    "resendCode": "Resend Code",
    "verifyCode": "Verify Code"
  },
  "backButton": {
    "back": "Back"
  },
  "settings": {
    "about": "About",
    "app_name": "App Name",
    "arabic": "Arabic",
    "english": "English",
    "generale": "General",
    "github": "Github",
    "language": "Language",
    "links": "Links",
    "logout": "Logout",
    "clear_cache": "Clear Cache",
    "more": "More",
    "privacy": "Privacy Policy",
    "rate": "Rate",
    "share": "Share",
    "support": "Support",
    "support_us": "Support Us",
    "terms": "Terms of Service",
    "theme": {
      "dark": "Dark",
      "light": "Light",
      "system": "System",
      "title": "Theme"
    },
    "title": "Settings",
    "version": "Version",
    "website": "Website"
  },
  "welcome": "Welcome to obytes app site",
  "account": {
    "eonCredits": "Eon Credit",
    "moreCredit": "Get more credit",
    "profile": "Profile",
    "paymentMethods": "Payment Methods",
    "receipts": "Receipts",
    "referrals": "Referrals",
    "becomeAPartner": "Become a Partner",
    "supportFaq": "Support",
    "legal": "Legal",
    "logout": "Log out",
    "logoutMessage": "Are you sure you want to log out?",
    "cancel": "Cancel",
    "clearCache": "Clear Cache"
  },
  "profile": {
    "name": "Name",
    "email": "Email",
    "phoneNumber": "Phone Number",
    "password": "Password",
    "deleteAccount": "Delete account",
    "deleteAccountModalTitle": "Delete account and data",
    "deleteAccountModalBody": "Are you sure you want to delete your account and all data",
    "cancel": "Cancel",
    "delete": "Delete"
  },
  "profileName": {
    "update": "Update Name"
  },
  "profileEmail": {
    "notVerified": "Email is not verified",
    "verified": "Email is verified",
    "verifyInfo": "We will send a link to your new email address to verify it. Your login email will be updated as well.",
    "update": "Update Email",
    "resend": "Resend Email"
  },
  "profilePhone": {
    "smsInfo": "We will send an sms to your new phone number to verify it.",
    "update": "Update"
  },
  "profilePassword": {
    "instructions": "Your password must include at least 8 characters.",
    "update": "Update Password",
    "forgotPassword": "Forgot Password?"
  },
  "paymentMethods": {
    "editButton": "Edit",
    "addACreditCard": "Add A Credit Card",
    "edit": "Edit {{brand}} ****{{last4}}",
    "expirationDate": "Expiration date: {{month}}/{{year}}",
    "defaultCard": "Default Card",
    "setDefaultCard": "Set Default card",
    "removeCard": "Remove card",
    "addACard": "Add a card",
    "creditCard": "Credit Card",
    "applePay": "Apple Pay",
    "googlePay": "Google Pay",
    "save": "Save",
    "removeCardConfirm": "Are you sure you want to delete your card?",
    "cancel": "Cancel",
    "delete": "Delete"
  },
  "tripHistory": {
    "city": "{{city}}",
    "dateRange": "{{dateRange}}",
    "showMore": "Show More"
  },
  "tripHistoryBreakdown": {
    "summary": "Summary",
    "tolls": "Tolls",
    "incidentals": "Incidentals"
  },
  "receipt": {
    "rentalDetails": "Rental Details",
    "viewPdf": "View PDF",
    "tripId": "ID",
    "pickup": "Pickup",
    "return": "Return",
    "pickupLocation": "Pick up location",
    "deliveryLocation": "Delivery location",
    "returnLocation": "Return location",
    "rentalBreakdown": "Rental breakdown",
    "vehicle": "Vehicle",
    "extrasAndServices": "Extras and services",
    "additionalMiles": "Additional miles",
    "insurance": "Insurance",
    "charging": "Charging",
    "supercharging": "Supercharging",
    "incidentals": "Incidentals",
    "viewIncidentals": "View Incidentals",
    "tolls": "Tolls",
    "viewTolls": "View Tolls",
    "payments": "Payments",
    "subtotal": "Subtotal",
    "salesTax": "Sales Tax",
    "salesTaxTooltip": "Sales tax may apply to your rental based on the pickup location. Tax rates vary by state and territory.",
    "credit": "Credit",
    "adjustments": "Adjustments",
    "total": "Total",
    "outstandingBalance": "Outstanding Balance"
  },
  "tolls": {
    "location": "Location",
    "time": "Time",
    "cost": "Cost",
    "processingFee": "Processing Fee"
  },
  "incidentals": {
    "name": "Name",
    "attachments": "Attachments",
    "date": "Date",
    "cost": "Cost",
    "processingFee": "Processing Fee",
    "paymentStatus": "Payment Status"
  },
  "mediaViewer": {
    "pictures": "Pictures",
    "pdf": "PDF",
    "pdfName": "{{pdfName}}"
  },
  "status": {
    "tripIsCompleted": "Trip is completed",
    "receiptInProgress": "Receipt in progress",
    "outstandingBalance": "Outstanding balance"
  },
  "referrals": {
    "title": "Refer a Friend!",
    "guestDescription": "Refer a guest and earn $35 in Eon credit when they complete their first trip.",
    "partnerDescription": "Refer a partner and grow the Eon community and earn $150 in Eon credit once a trip is completed with one of their cars.",
    "share": "Share"
  },
  "legal": {
    "policies": "Policies",
    "privacyPolicy": "Privacy policy",
    "rentalTerms": "Rental terms and conditions"
  },
  "supportFaq": {
    "contact": "Contact",
    "email": "Email",
    "emailRespondTime": "We usually respond within 12 hours",
    "phone": "Phone",
    "supportNumber": "+1 855-598-7090",
    "supportEmail": "support@eonrides.com",
    "generalSupport": "General Support",
    "faq": "F.A.Q."
  },
  "contactSupport": {
    "title": "Contact Support",
    "body": "Need help? Give us a call or send us an email and we'll get back to you.",
    "call": "Call +1 855-598-7090",
    "email": "Email support@eonrides.com"
  },
  "subscriptions": {
    "customizeSubscription": "Customize Your Subscription",
    "customSubscriptionSubtitle": "Tailor-made EV subscriptions delivered straight to your door.",
    "locationAndStartDate": "Location And Start Date",
    "noCarsAvailable": "No Cars Available",
    "noCarsAvailableBody": "Try changing your address or start date.",
    "optionUnavailable": "That option just became unavailable. Please refresh and choose again.",
    "subscriptionPeriod": "Subscription Period",
    "commitmentBody": "Pick how long you want to drive, the longer you subscribe, the more you save.",
    "autoRenewTitle": "All plans auto-renew until cancelled",
    "autoRenewBody": "Billed 3 days before each renewal. Weekly and Monthly can be cancelled between renewals.",
    "periodTitle": "{{title}}",
    "periodFooterTitle": "Available models starting from",
    "periodFooterBodyBold": "${{amount}}",
    "periodFooterBody": "/ {{period}} + ${{deposit}} Initiation Fee",
    "faqTitle": "Frequently Asked Questions",
    "chooseCarModel": "Choose Your Car Model",
    "modelAmount": " / {{period}}",
    "chooseCarTrim": "Choose Your Trim",
    "chooseCarTrimBody": "Select your preferred trim from the available options in your area. Exterior car colors may vary.",
    "autopilot": "Autopilot options",
    "autopilotStandardTitle": "Standard",
    "autopilotStandardBody": "Autosteer, Smart Cruise Control, and emergency braking.",
    "chooseMileagePlan": "Mileage Plan",
    "chooseYourProtection": "Protection Plan",
    "enterDiscountCode": "Enter Discount Code",
    "addPersonalDetails": "Add Your Personal Details",
    "furtherQuestions": "Contact Support",
    "overviewButtonInactiveText": "Next",
    "overviewButtonActiveText": "Next",
    "overviewButtonPay": "Pay ${{amount}}",
    "overviewReviewPolicies": "Review Policies",
    "overviewTOC": "Terms and conditions",
    "overviewTitle": "Subscription Overview",
    "overviewLocation": "Pick Up Location",
    "overviewDeliveryLocation": "Delivered to",
    "overviewStartDate": "Start Date",
    "overviewCommitment": "{{period}} Rate",
    "overviewDeliveryFee": "One-Time Delivery Fee",
    "overviewDeliveryFeeTooltip": "Free delivery is not available for this model. Our delivery fee is calculated based on the delivery distance and the car's location.",
    "overviewMileage": "{{miles}} / {{period}}",
    "overviewDeposit": "One-time refundable deposit",
    "overviewTotal": "{{period}} Total",
    "overviewButton": "Subscribe for ${{amount}} / {{period}}",
    "breakdown": "Subscription Breakdown",
    "whenChargedTitle": "When Will You Be Charged?",
    "whenChargedTodayLabel": "Today",
    "whenChargedToday": "First {{period}} (${{amount}})",
    "whenChargedDepositLabel": "24h before trip starts",
    "whenChargedDeposit": "Refundable Deposit (${{amount}})",
    "whenChargedRenewalLabel": "3 days before renewal date",
    "whenChargedRenewal": "Next {{period}} (${{amount}})",
    "edit": "Edit",
    "thankYouTitle": "You're Booked!",
    "thankYouBody": "We've got your subscription locked in and can't wait to get your car over to you",
    "thankYouNext": "What's Next?",
    "thankYouVerifyInfo": "In the next 24 hours, we'll be matching you to the car you chose within our inventory and preparing to get it over to you. Once we've confirmed your exact car's VIN, you'll receive another email confirmation with all the details including the license plate, Vin number, and other details.",
    "thankYouLink": "You'll receive a link to upload your license and/or insurance for verification",
    "thankYouFollowUp": "We'll authorize your deposit 24 hours before your trip starts once verification is complete",
    "thankYouFinalize": "Your rental agent will reach out to you directly and coordinate the best time to handoff the vehicle for your chosen start date.",
    "thankYouMeantime": "In The Meantime:",
    "thankYouContact": "Take a look at our FAQs to get familiar with your car and your subscription experience.",
    "thankYouWebsite": "You can reach out to our team at any time if you have any additional questions or needs."
  },
  "calendar": {
    "headerStartReturn": "Start And Return Date",
    "headerStart": "Start Date",
    "headerEnd": "End Date",
    "chooseStartDate": "Choose Start Date",
    "selectStartDate": "Select start date"
  },
  "autocomplete": {
    "searchForAddress": "Search for an address"
  },
  "checkoutForm": {
    "addPaymentInformation": "Add Payment Information"
  },
  "canvas": {
    "sign": "Sign above to agree with the terms and conditions",
    "clear": "Clear"
  },
  "searchBarButton": {
    "where": "Where",
    "fromTo": "From - To"
  },
  "home": {
    "where": "Where"
  },
  "search": {
    "pickup": "Pickup",
    "delivery": "Delivery",
    "whereWhen": "Where & When",
    "popularCities": "Popular Cities",
    "where": "Where",
    "when": "When",
    "deliveryAddress": "Delivery address",
    "returnAddress": "Return address",
    "search": "Search",
    "mapView": "Map View",
    "listView": "List View",
    "refresh": "Refresh",
    "howDeliveryFees": "See how we calculate delivery fees",
    "resetFilters": "Reset Filters"
  },
  "buttonFilter": {
    "clearAll": "Clear All",
    "clear": "Clear"
  },
  "carCard": {
    "milesFromAddress": "{{miles}} Miles From Address",
    "deliveryAvailable": "Delivery Available"
  },
  "carId": {
    "pickupAndReturnDetails": "Pickup & Return Details",
    "deliveryAndReturnDetails": "Delivery & Return Details",
    "deliveryLocation": "Delivery Location",
    "pickupLocation": "Pickup Location",
    "returnLocation": "Return Location",
    "carLocation": "Car Location",
    "pickupAndReturn": "Pickup & Return",
    "pickupAndReturnBody": "You’ll need to pickup and return the car from the chosen location.",
    "delivery": "Delivery",
    "deliveryBody": "Delivery to airport, hotel or destination of your choice. Includes both delivery and pick.",
    "insurancePlans": "Protection Plans",
    "deliveryFee": "Delivery Fee",
    "ownInsuranceTitle": "Own Insurance",
    "ownInsuranceBody": "Own Insurance",
    "ownInsuranceUpgrade": "Switch To Minimum Protection",
    "ownInsuranceKeep": "I'll Use My Own Insurance",
    "checkout": "Checkout",
    "carNotAvailable": "Car Is Not Available",
    "carNotAvailableBody": "The car you selected is no longer available. This may happen if another user booked it recently.",
    "backToSearch": "Back To Search"
  },
  "discount": {
    "addDiscountCode": "Add Discount Code",
    "enterDiscountCodeLabel": "Enter your discount code here",
    "redeemCode": "Redeem Code"
  },
  "checkout": {
    "finishProfileTitle": "Finish Your Eon Account",
    "rentalSummary": "Rental Summary",
    "driversProfile": "Driver's Profile",
    "beforeYouBook": "Before You Book",
    "securityDeposit": "Security deposit: A ${{amount}} authorization will be placed 24 hours before pickup and released once the vehicle is safely returned. Certain vehicles — including Cybertrucks, Plaid models, Rivians, Lucids, and rentals over 30 days — require a $1,000 deposit.",
    "dailyMilesAllowance": "Free {{miles}} miles daily. Excess miles cost ${{amountPerMile}} per mile.",
    "cancellationPolicy": "Cancellation Policy: Get a full refund minus 5% (payment processing costs) if you cancel at least 24 hours before your trip. Cancellations within 24 hours or no shows are non-refundable.",
    "whatsNext": "What's Next?",
    "driversLicenseLink": "After booking, you'll get a link to upload your driver's license.",
    "receiveCarDetails": "You’ll receive your car’s license plate, driving code, and dedicated rental agent’s phone number 1 hour before your trip.",
    "downloadEonApp": "After booking, download the Eon app to control your car’s features from its control panel.",
    "selectedPaymentMethod": "Selected Payment Method",
    "applyEonCredits": "Apply Eon Credits",
    "availableAmount": "Available Amount ${{amount}}",
    "availableEonCredits": "Available Eon Credits: ${{amount}}",
    "noEonCredits": "You Have No Eon Credits Available",
    "availableEonCreditsPlaceholder": "Enter an amount up to ${{amount}}",
    "applyCredit": "Apply Credit",
    "digitalSignature": "Digital Signature",
    "digitalSignatureBody": "Sign above to agree with the terms & conditions.",
    "termsAndConditions": "Terms and Conditions",
    "termsAndConditionsBody": "Please review our policies. By making a payment, you automatically accept our terms and conditions and our policies.",
    "reviewPolicies": "Review Policies",
    "includingTaxes": "Including Taxes",
    "confirmBooking": "Confirm Booking",
    "addAPaymentMethod": "Add A Payment Method",
    "addAPaymentMethodBody": "We will need a card on file to handle any additional charges during your trip."
  },
  "checkoutComplete": {
    "header": "{{name}}... you're booked!",
    "body": "Your ride is booked! We sent a confirmation email to {{email}}.",
    "rentalTimeline": "Your Eon Rental Timeline",
    "referAFriend": "Refer A Friend",
    "referAFriendBody": "Refer a friend and earn $35 in Eon credit when they complete their first trip. They’ll get a $35 discount when they book.",
    "referralLink": "Referral link",
    "share": "Share",
    "manageBookingsFromApp": "Manage Your Bookings From The Eon App",
    "manageBookingsFromAppBody": "Download the Eon app so you can control your car’s connected features straight from the app!",
    "manageYourBookings": "Manage Your Bookings",
    "newSearch": "New Search"
  },
  "rentalAgreement": {
    "rentalAgreement": "Rental Agreement: #TR-{{id}}"
  },
  "trips": {
    "activeTrips": "Active Trips",
    "emptyStateBody": "Book your first car and your upcoming trips will show up here.",
    "emptyStateCta": "Book Your First Car",
    "emptyStateTitle": "No Trips Yet",
    "pastTrips": "Past Trips"
  },
  "tripCard": {
    "viewTripDetails": "View Trip Details"
  },
  "tripDetails": {
    "controlPanelTitle": "Car Control Panel",
    "controlPanelBody": "Unlock, lock, adjust AC, and manage your car",
    "controlPanelDisabled": "Check-in first to unlock control panel",
    "cancelTripModalTitle": "Cancel This Trip?",
    "cancelTripModalSubtitle": "You'll need to rebook if you change your mind",
    "cancelTripModalLeftButtonKeepTrip": "Keep Trip",
    "cancelTripModalLeftButtonContactSupport": "Contact Support",
    "cancelTripModalRightButton": "Cancel Trip"
  },
  "additionalDriver": {
    "driverName": "{{name}}",
    "driverEmail": "{{email}}",
    "driverStatus": "{{status}}",
    "removeDriverTitle": "Remove Driver",
    "removeDriverBody": "Are you sure you want to remove this driver?",
    "removeDriverCancel": "Cancel",
    "removeDriverRemove": "Remove"
  },
  "tutorial": {
    "usedTeslaFirstTime": "First time",
    "usedTeslaOnceOrTwice": "Once or twice",
    "usedTeslaManyTimes": "Many times"
  },
  "checkin": {
    "cancelWarningTitle": "Complete Check-In",
    "cancelWarningBody": "You need to complete the check-in to get access to your car.",
    "cancelWarningCancelButton": "Go Back",
    "cancelWarningContinueButton": "Check In"
  },
  "uploadPhotos": {
    "leaveModalTitle": "Back to Trip",
    "leaveModalCancelButton": "Cancel",
    "leaveModalLeaveButton": "Leave"
  },
  "carDetails": {
    "deliveryTitle": "{{phone}}",
    "deliveryBody": "Your delivery driver's phone"
  },
  "dropoff": {
    "finishTripModalTitle": "Finish Trip",
    "finishTripModalBody": "End your rental after you've parked the car back at it's dropoff address",
    "finishTripModalConfirm": "Finish Trip",
    "finishTripModalCancel": "Cancel"
  },
  "partner": {
    "sidebar": {
      "dashboard": "Dashboard",
      "cars": "Cars",
      "reservations": "Reservations",
      "customers": "Customers",
      "calendar": "Calendar",
      "locations": "Locations",
      "payouts": "Payouts",
      "eonOne": "EonOne",
      "settings": "Settings",
      "integrations": "Integrations",
      "account": "Account",
      "profile": "Profile",
      "resources": "Resources",
      "mobileApp": "Mobile App",
      "bankAccount": "Bank Account",
      "ownerGuide": "Owner Guide & Terms",
      "support": "Support",
      "more": "More",
      "whatsNew": "What's New",
      "referAFriend": "Refer a friend",
      "submitFeedback": "Submit feedback",
      "howEonWorks": "How Eon works",
      "logOut": "Log out",
      "switchToGuest": "Switch to guest"
    },
    "more": {
      "bankAccount": "Bank Account",
      "ownerGuide": "Owner Guide & Terms",
      "locations": "Locations",
      "whatsNew": "What's New",
      "referAFriend": "Refer a friend",
      "submitFeedback": "Submit feedback"
    },
    "whatsNew": {
      "title": "What's New",
      "all": "All",
      "newFeature": "New Feature",
      "improved": "Improved",
      "fixed": "Fixed",
      "empty": "No updates to show",
      "versionDate": "Version {{version}} • {{date}}"
    },
    "bankAccount": {
      "title": "Bank Account",
      "removeTitle": "Remove Bank Account?",
      "removeBody": "Without a bank account on file, we can't send your payouts. You'll need to add a new one to keep getting paid.",
      "remove": "Remove Bank Account",
      "cancel": "Cancel"
    },
    "cars": {
      "deliveryEarningsCaption": "Deliver the car for extra earnings starting at ${{amount}} additional earnings per rental and increasing based on the distance"
    }
  }
}
